"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.availableAssets = exports.availableTypes = void 0;
// GENERATED FILE, PLEASE DO NOT EDIT
var availableTypes = {
  AddCircleFill: 'AddCircleFill',
  AddCircleLine: 'AddCircleLine',
  AddSquareFill: 'AddSquareFill',
  AddSquareLine: 'AddSquareLine',
  Add: 'Add',
  ArrowDoubleDownLeft: 'ArrowDoubleDownLeft',
  ArrowDoubleDownRight: 'ArrowDoubleDownRight',
  ArrowDoubleDown: 'ArrowDoubleDown',
  ArrowDoubleLeft: 'ArrowDoubleLeft',
  ArrowDoubleRight: 'ArrowDoubleRight',
  ArrowDoubleUpLeft: 'ArrowDoubleUpLeft',
  ArrowDoubleUpRight: 'ArrowDoubleUpRight',
  ArrowDoubleUp: 'ArrowDoubleUp',
  ArrowDownLeft: 'ArrowDownLeft',
  ArrowDownRight: 'ArrowDownRight',
  ArrowDown: 'ArrowDown',
  ArrowLeft: 'ArrowLeft',
  ArrowRight: 'ArrowRight',
  ArrowUpLeft: 'ArrowUpLeft',
  ArrowUpRight: 'ArrowUpRight',
  ArrowUp: 'ArrowUp',
  BlobAlmondblob: 'BlobAlmondblob',
  BlobAvoblob: 'BlobAvoblob',
  BlobMusselblob: 'BlobMusselblob',
  BlobPearblob: 'BlobPearblob',
  BlobRibsblob: 'BlobRibsblob',
  BlobSteakblob: 'BlobSteakblob',
  BoltFill: 'BoltFill',
  BoltLine: 'BoltLine',
  BookmarkFillLight: 'BookmarkFillLight',
  BookmarkFill: 'BookmarkFill',
  BookmarkLineLight: 'BookmarkLineLight',
  BookmarkLine: 'BookmarkLine',
  BrowseFill: 'BrowseFill',
  BrowseLine: 'BrowseLine',
  CalendarAddFill: 'CalendarAddFill',
  CalendarAddLine: 'CalendarAddLine',
  CalendarCancelFill: 'CalendarCancelFill',
  CalendarCancelLine: 'CalendarCancelLine',
  CalendarCheckFill: 'CalendarCheckFill',
  CalendarCheckLine: 'CalendarCheckLine',
  CalendarFill: 'CalendarFill',
  CalendarLine: 'CalendarLine',
  CameraFill: 'CameraFill',
  CameraLine: 'CameraLine',
  CardAmexColor: 'CardAmexColor',
  CardAmexMonocolor: 'CardAmexMonocolor',
  CardApplePayColor: 'CardApplePayColor',
  CardApplePayMonocolor: 'CardApplePayMonocolor',
  CardCaviarColor: 'CardCaviarColor',
  CardCaviarMonocolor: 'CardCaviarMonocolor',
  CardChaseColor: 'CardChaseColor',
  CardChaseMonocolor: 'CardChaseMonocolor',
  CardDinersClubColor: 'CardDinersClubColor',
  CardDinersClubMonocolor: 'CardDinersClubMonocolor',
  CardDiscoverColor: 'CardDiscoverColor',
  CardDiscoverMonocolor: 'CardDiscoverMonocolor',
  CardDoordashColor: 'CardDoordashColor',
  CardDoordashMonocolor: 'CardDoordashMonocolor',
  CardFill: 'CardFill',
  CardGooglePayColor: 'CardGooglePayColor',
  CardGooglePayMonocolor: 'CardGooglePayMonocolor',
  CardIdFill: 'CardIdFill',
  CardIdLine: 'CardIdLine',
  CardLine: 'CardLine',
  CardLoyaltyFill: 'CardLoyaltyFill',
  CardLoyaltyLine: 'CardLoyaltyLine',
  CardMastercardColor: 'CardMastercardColor',
  CardMastercardMonocolor: 'CardMastercardMonocolor',
  CardPaypalColor: 'CardPaypalColor',
  CardPaypalMonocolor: 'CardPaypalMonocolor',
  CardVenmoColor: 'CardVenmoColor',
  CardVenmoMonocolor: 'CardVenmoMonocolor',
  CardVisaColor: 'CardVisaColor',
  CardVisaMonocolor: 'CardVisaMonocolor',
  CaretDown: 'CaretDown',
  CaretLeft: 'CaretLeft',
  CaretRight: 'CaretRight',
  CaretUp: 'CaretUp',
  CartFill: 'CartFill',
  CartLine: 'CartLine',
  CateringFill: 'CateringFill',
  CateringLine: 'CateringLine',
  Caviar: 'Caviar',
  Challenge: 'Challenge',
  ChatDefaultFill: 'ChatDefaultFill',
  ChatDefaultLine: 'ChatDefaultLine',
  CheckCircleFill: 'CheckCircleFill',
  CheckCircleLine: 'CheckCircleLine',
  CheckSquareFill: 'CheckSquareFill',
  CheckSquareLine: 'CheckSquareLine',
  CheckSquareOffLine: 'CheckSquareOffLine',
  Check: 'Check',
  ChevronDoubleDown: 'ChevronDoubleDown',
  ChevronDoubleLeft: 'ChevronDoubleLeft',
  ChevronDoubleRight: 'ChevronDoubleRight',
  ChevronDoubleUp: 'ChevronDoubleUp',
  ChevronDown: 'ChevronDown',
  ChevronLeft: 'ChevronLeft',
  ChevronRight: 'ChevronRight',
  ChevronUp: 'ChevronUp',
  CloseCircleFill: 'CloseCircleFill',
  CloseCircleLine: 'CloseCircleLine',
  CloseSquareFill: 'CloseSquareFill',
  CloseSquareLine: 'CloseSquareLine',
  Close: 'Close',
  Code: 'Code',
  CoffeeFill: 'CoffeeFill',
  CoffeeLine: 'CoffeeLine',
  CookingFill: 'CookingFill',
  CookingLine: 'CookingLine',
  CopyFill: 'CopyFill',
  CopyLine: 'CopyLine',
  DashboardFill: 'DashboardFill',
  DashboardLine: 'DashboardLine',
  DealsFill: 'DealsFill',
  DealsLine: 'DealsLine',
  DeliveryTruckFill: 'DeliveryTruckFill',
  DeliveryTruckLine: 'DeliveryTruckLine',
  DevicePhone: 'DevicePhone',
  DevicePosFill: 'DevicePosFill',
  DevicePosLine: 'DevicePosLine',
  DeviceTablet: 'DeviceTablet',
  DirectionsFill: 'DirectionsFill',
  DirectionsLine: 'DirectionsLine',
  DockDownLeftLine: 'DockDownLeftLine',
  DockDownRightLine: 'DockDownRightLine',
  DockLeftFill: 'DockLeftFill',
  DockLeftLine: 'DockLeftLine',
  DockRightFill: 'DockRightFill',
  DockRightLine: 'DockRightLine',
  DockUpLeftLine: 'DockUpLeftLine',
  DockUpRightLine: 'DockUpRightLine',
  DownloadFill: 'DownloadFill',
  DownloadLine: 'DownloadLine',
  EditAddFill: 'EditAddFill',
  EditAddLine: 'EditAddLine',
  EditFill: 'EditFill',
  EditLine: 'EditLine',
  EmailFill: 'EmailFill',
  EmailLine: 'EmailLine',
  ErrorFill: 'ErrorFill',
  ErrorLine: 'ErrorLine',
  EyeHiddenFill: 'EyeHiddenFill',
  EyeHiddenLine: 'EyeHiddenLine',
  EyeVisibleFill: 'EyeVisibleFill',
  EyeVisibleLine: 'EyeVisibleLine',
  FavoriteFillLight: 'FavoriteFillLight',
  FavoriteFill: 'FavoriteFill',
  FavoriteLineLight: 'FavoriteLineLight',
  FavoriteLine: 'FavoriteLine',
  FaxFill: 'FaxFill',
  FaxLine: 'FaxLine',
  FigmaFill: 'FigmaFill',
  FigmaLine: 'FigmaLine',
  FilterFill: 'FilterFill',
  FilterLine: 'FilterLine',
  FlagFill: 'FlagFill',
  FlagLine: 'FlagLine',
  FlowerFill: 'FlowerFill',
  FlowerLine: 'FlowerLine',
  FoodBowlFill: 'FoodBowlFill',
  FoodBowlLine: 'FoodBowlLine',
  FoodLine: 'FoodLine',
  FunnelFill: 'FunnelFill',
  FunnelLine: 'FunnelLine',
  GiftFill: 'GiftFill',
  GiftLine: 'GiftLine',
  GlobeFill: 'GlobeFill',
  GlobeLine: 'GlobeLine',
  HalfFill: 'HalfFill',
  HalfLine: 'HalfLine',
  HelpCircleFill: 'HelpCircleFill',
  HelpCircleLine: 'HelpCircleLine',
  HelpLifesaver: 'HelpLifesaver',
  HomeFill: 'HomeFill',
  HomeLine: 'HomeLine',
  InfoCircleFill: 'InfoCircleFill',
  InfoCircleLine: 'InfoCircleLine',
  InfoFill: 'InfoFill',
  InfoLine: 'InfoLine',
  InsightFill: 'InsightFill',
  InsightLine: 'InsightLine',
  KeyFill: 'KeyFill',
  KeyLine: 'KeyLine',
  LinkBroken: 'LinkBroken',
  LinkExternalFill: 'LinkExternalFill',
  LinkExternalLine: 'LinkExternalLine',
  Link: 'Link',
  List: 'List',
  LocationGpsFill: 'LocationGpsFill',
  LocationGpsLine: 'LocationGpsLine',
  LocationPinDisabledFill: 'LocationPinDisabledFill',
  LocationPinDisabledLine: 'LocationPinDisabledLine',
  LocationPinEnabledFill: 'LocationPinEnabledFill',
  LocationPinEnabledLine: 'LocationPinEnabledLine',
  LocationPointerFill: 'LocationPointerFill',
  LocationPointerLine: 'LocationPointerLine',
  LockedFill: 'LockedFill',
  LockedLine: 'LockedLine',
  LogoAdtColor: 'LogoAdtColor',
  LogoAdtMonocolor: 'LogoAdtMonocolor',
  LogoAfterpayColor: 'LogoAfterpayColor',
  LogoAfterpayMonocolor: 'LogoAfterpayMonocolor',
  LogoAfterpay: 'LogoAfterpay',
  LogoAndroid: 'LogoAndroid',
  LogoApple: 'LogoApple',
  LogoChase: 'LogoChase',
  LogoCheckrColor: 'LogoCheckrColor',
  LogoCheckrMonocolor: 'LogoCheckrMonocolor',
  LogoDashpassMonocolor: 'LogoDashpassMonocolor',
  LogoDashpassNew: 'LogoDashpassNew',
  LogoDashpass: 'LogoDashpass',
  LogoDoordash: 'LogoDoordash',
  LogoFacebook: 'LogoFacebook',
  LogoGithubColor: 'LogoGithubColor',
  LogoGithubMonocolor: 'LogoGithubMonocolor',
  LogoGlassdoor: 'LogoGlassdoor',
  LogoGoogle: 'LogoGoogle',
  LogoInstagram: 'LogoInstagram',
  LogoLineColor: 'LogoLineColor',
  LogoLineMonocolor: 'LogoLineMonocolor',
  LogoLinkedin: 'LogoLinkedin',
  LogoMedium: 'LogoMedium',
  LogoPaypayColor: 'LogoPaypayColor',
  LogoPaypayMonocolor: 'LogoPaypayMonocolor',
  LogoSiftColor: 'LogoSiftColor',
  LogoSiftMonocolor: 'LogoSiftMonocolor',
  LogoSquare: 'LogoSquare',
  LogoStripeColor: 'LogoStripeColor',
  LogoStripeMonocolor: 'LogoStripeMonocolor',
  LogoTwitter: 'LogoTwitter',
  LogoVenmo: 'LogoVenmo',
  LogoWebhooks: 'LogoWebhooks',
  LogoutFill: 'LogoutFill',
  LogoutLine: 'LogoutLine',
  MapFill: 'MapFill',
  MapLine: 'MapLine',
  MaskFill: 'MaskFill',
  MaskLine: 'MaskLine',
  MenuEditFill: 'MenuEditFill',
  MenuEditLine: 'MenuEditLine',
  MenuShare: 'MenuShare',
  Menu: 'Menu',
  MerchantDisabledFill: 'MerchantDisabledFill',
  MerchantDisabledLine: 'MerchantDisabledLine',
  MerchantFill: 'MerchantFill',
  MerchantLine: 'MerchantLine',
  MicrophoneFill: 'MicrophoneFill',
  MicrophoneLine: 'MicrophoneLine',
  MoneyBank: 'MoneyBank',
  MoneyCircleDisabledFill: 'MoneyCircleDisabledFill',
  MoneyCircleDisabledLine: 'MoneyCircleDisabledLine',
  MoneyCircleEnabledFill: 'MoneyCircleEnabledFill',
  MoneyCircleEnabledLine: 'MoneyCircleEnabledLine',
  MoneyCircleFill: 'MoneyCircleFill',
  MoneyCircleLine: 'MoneyCircleLine',
  MoneyDefault: 'MoneyDefault',
  MoneyEuroCircleDisabledFill: 'MoneyEuroCircleDisabledFill',
  MoneyEuroCircleDisabledLine: 'MoneyEuroCircleDisabledLine',
  MoneyEuroCircleEnabledFill: 'MoneyEuroCircleEnabledFill',
  MoneyEuroCircleEnabledLine: 'MoneyEuroCircleEnabledLine',
  MoneyEuro: 'MoneyEuro',
  MoneyYenCircleDisabledFill: 'MoneyYenCircleDisabledFill',
  MoneyYenCircleDisabledLine: 'MoneyYenCircleDisabledLine',
  MoneyYenCircleEnabledFill: 'MoneyYenCircleEnabledFill',
  MoneyYenCircleEnabledLine: 'MoneyYenCircleEnabledLine',
  MoneyYen: 'MoneyYen',
  MoreHorizontal: 'MoreHorizontal',
  MoreVertical: 'MoreVertical',
  NotifyFill: 'NotifyFill',
  NotifyLine: 'NotifyLine',
  Number1Fill: 'Number1Fill',
  Number1Line: 'Number1Line',
  Number2Fill: 'Number2Fill',
  Number2Line: 'Number2Line',
  Number3Fill: 'Number3Fill',
  Number3Line: 'Number3Line',
  Number4Fill: 'Number4Fill',
  Number4Line: 'Number4Line',
  Number5Fill: 'Number5Fill',
  Number5Line: 'Number5Line',
  Number6Fill: 'Number6Fill',
  Number6Line: 'Number6Line',
  Number7Fill: 'Number7Fill',
  Number7Line: 'Number7Line',
  Number8Fill: 'Number8Fill',
  Number8Line: 'Number8Line',
  Number9Fill: 'Number9Fill',
  Number9Line: 'Number9Line',
  Office: 'Office',
  OrderBagFill: 'OrderBagFill',
  OrderBagLine: 'OrderBagLine',
  OrderBatchFill: 'OrderBatchFill',
  OrderBatchLine: 'OrderBatchLine',
  OrderHotbagFill: 'OrderHotbagFill',
  OrderHotbagLine: 'OrderHotbagLine',
  OrderIncorrectFill: 'OrderIncorrectFill',
  OrderIncorrectLine: 'OrderIncorrectLine',
  OrderLargeFillFrCa: 'OrderLargeFillFrCa',
  OrderLargeFill: 'OrderLargeFill',
  OrderLargeLineFrCa: 'OrderLargeLineFrCa',
  OrderLargeLine: 'OrderLargeLine',
  OrderMediumFillFrCa: 'OrderMediumFillFrCa',
  OrderMediumFill: 'OrderMediumFill',
  OrderMediumLineFrCa: 'OrderMediumLineFrCa',
  OrderMediumLine: 'OrderMediumLine',
  OrderProtocol: 'OrderProtocol',
  OrderSmallFillFrCa: 'OrderSmallFillFrCa',
  OrderSmallFill: 'OrderSmallFill',
  OrderSmallLineFrCa: 'OrderSmallLineFrCa',
  OrderSmallLine: 'OrderSmallLine',
  ParkingEsMxFill: 'ParkingEsMxFill',
  ParkingEsMxLine: 'ParkingEsMxLine',
  ParkingFill: 'ParkingFill',
  ParkingLine: 'ParkingLine',
  PauseFill: 'PauseFill',
  PauseLine: 'PauseLine',
  PaymentFill: 'PaymentFill',
  PaymentLine: 'PaymentLine',
  PeopleAddFill: 'PeopleAddFill',
  PeopleAddLine: 'PeopleAddLine',
  PeopleGroupFill: 'PeopleGroupFill',
  PeopleGroupLine: 'PeopleGroupLine',
  PersonFindFill: 'PersonFindFill',
  PersonFindLine: 'PersonFindLine',
  PersonProfileFill: 'PersonProfileFill',
  PersonProfileLine: 'PersonProfileLine',
  PersonUserFill: 'PersonUserFill',
  PersonUserLine: 'PersonUserLine',
  PetsFill: 'PetsFill',
  PetsLine: 'PetsLine',
  PharmacyFill: 'PharmacyFill',
  PharmacyLine: 'PharmacyLine',
  PhoneCallFill: 'PhoneCallFill',
  PhoneCallLine: 'PhoneCallLine',
  PhotoFill: 'PhotoFill',
  PhotoFlipFill: 'PhotoFlipFill',
  PhotoFlipLine: 'PhotoFlipLine',
  PhotoLine: 'PhotoLine',
  PhotoRotateFill: 'PhotoRotateFill',
  PhotoRotateLine: 'PhotoRotateLine',
  PhotoUploadFill: 'PhotoUploadFill',
  PhotoUploadLine: 'PhotoUploadLine',
  PhotosFill: 'PhotosFill',
  PhotosLine: 'PhotosLine',
  PlayFill: 'PlayFill',
  PlayLine: 'PlayLine',
  PluginFill: 'PluginFill',
  PluginLine: 'PluginLine',
  PrintFill: 'PrintFill',
  PrintLine: 'PrintLine',
  PrismFill: 'PrismFill',
  PrismLine: 'PrismLine',
  ProhibitedFill: 'ProhibitedFill',
  ProhibitedLine: 'ProhibitedLine',
  PromoBullhornFill: 'PromoBullhornFill',
  PromoBullhornLine: 'PromoBullhornLine',
  PromoFill: 'PromoFill',
  PromoLine: 'PromoLine',
  RadioOffCircleLine: 'RadioOffCircleLine',
  RadioOnCircleFill: 'RadioOnCircleFill',
  RearrangeVertical: 'RearrangeVertical',
  ReceiptCancelOrderFill: 'ReceiptCancelOrderFill',
  ReceiptCancelOrderLine: 'ReceiptCancelOrderLine',
  ReceiptFill: 'ReceiptFill',
  ReceiptLine: 'ReceiptLine',
  RefundFill: 'RefundFill',
  RefundLine: 'RefundLine',
  RewardFill: 'RewardFill',
  RewardLine: 'RewardLine',
  RobotFill: 'RobotFill',
  RobotLine: 'RobotLine',
  Rotate: 'Rotate',
  RunTestFill: 'RunTestFill',
  RunTest: 'RunTest',
  SafetyFill: 'SafetyFill',
  SafetyLine: 'SafetyLine',
  SatelliteFill: 'SatelliteFill',
  SatelliteLine: 'SatelliteLine',
  Scan: 'Scan',
  SearchFill: 'SearchFill',
  SearchLine: 'SearchLine',
  Search: 'Search',
  SendFill: 'SendFill',
  SendLine: 'SendLine',
  Send: 'Send',
  SettingsFill: 'SettingsFill',
  SettingsLine: 'SettingsLine',
  ShareFill: 'ShareFill',
  ShareLine: 'ShareLine',
  SignalHigh: 'SignalHigh',
  SignalLow: 'SignalLow',
  SignalMedium: 'SignalMedium',
  SkewHorizontalFill: 'SkewHorizontalFill',
  SkewHorizontalLine: 'SkewHorizontalLine',
  SkewVerticalFill: 'SkewVerticalFill',
  SkewVerticalLine: 'SkewVerticalLine',
  SmileyHappyFill: 'SmileyHappyFill',
  SmileyHappyLine: 'SmileyHappyLine',
  SmileyNeutralFill: 'SmileyNeutralFill',
  SmileyNeutralLine: 'SmileyNeutralLine',
  SmileySadFill: 'SmileySadFill',
  SmileySadLine: 'SmileySadLine',
  SortOrder: 'SortOrder',
  Sort: 'Sort',
  Sos: 'Sos',
  SpellingFill: 'SpellingFill',
  SpellingLine: 'SpellingLine',
  StarFill: 'StarFill',
  StarHalf: 'StarHalf',
  StarLine: 'StarLine',
  SubtractCircleFill: 'SubtractCircleFill',
  SubtractCircleLine: 'SubtractCircleLine',
  SubtractSquareFill: 'SubtractSquareFill',
  SubtractSquareLine: 'SubtractSquareLine',
  Subtract: 'Subtract',
  SwapCircleFill: 'SwapCircleFill',
  SwapCircleLine: 'SwapCircleLine',
  Swap: 'Swap',
  Sync: 'Sync',
  ThumbsDownFill: 'ThumbsDownFill',
  ThumbsDownLine: 'ThumbsDownLine',
  ThumbsUpFill: 'ThumbsUpFill',
  ThumbsUpLine: 'ThumbsUpLine',
  TimeFill: 'TimeFill',
  TimeLine: 'TimeLine',
  TippingFill: 'TippingFill',
  TippingLine: 'TippingLine',
  TipsStaffFill: 'TipsStaffFill',
  TipsStaffLine: 'TipsStaffLine',
  ToteFill: 'ToteFill',
  ToteLine: 'ToteLine',
  TrashFill: 'TrashFill',
  TrashLine: 'TrashLine',
  TrashRestoreFill: 'TrashRestoreFill',
  TrashRestoreLine: 'TrashRestoreLine',
  TrendDownCaret: 'TrendDownCaret',
  TrendUpCaret: 'TrendUpCaret',
  UnlockedFill: 'UnlockedFill',
  UnlockedLine: 'UnlockedLine',
  UploadFill: 'UploadFill',
  UploadLine: 'UploadLine',
  VehicleAirplane: 'VehicleAirplane',
  VehicleBikeFill: 'VehicleBikeFill',
  VehicleBikeLine: 'VehicleBikeLine',
  VehicleCar: 'VehicleCar',
  VehicleEbikeFill: 'VehicleEbikeFill',
  VehicleEbikeLine: 'VehicleEbikeLine',
  VehicleMotorcycleFill: 'VehicleMotorcycleFill',
  VehicleMotorcycleLine: 'VehicleMotorcycleLine',
  VehicleScooterFill: 'VehicleScooterFill',
  VehicleScooterLine: 'VehicleScooterLine',
  VehicleWalk: 'VehicleWalk',
  ViewCollapse: 'ViewCollapse',
  ViewExpand: 'ViewExpand',
  VolumeHighFill: 'VolumeHighFill',
  VolumeHighLine: 'VolumeHighLine',
  VolumeLowFill: 'VolumeLowFill',
  VolumeLowLine: 'VolumeLowLine',
  VolumeMuteFill: 'VolumeMuteFill',
  VolumeMuteLine: 'VolumeMuteLine',
  VolumeNoneFill: 'VolumeNoneFill',
  VolumeNoneLine: 'VolumeNoneLine',
  WarningCircleFill: 'WarningCircleFill',
  WarningCircleLine: 'WarningCircleLine',
  WarningFill: 'WarningFill',
  WarningLine: 'WarningLine',
  WarningTriangleFill: 'WarningTriangleFill',
  WarningTriangleLine: 'WarningTriangleLine',
  Wifi0Line: 'Wifi0Line',
  Wifi1Line: 'Wifi1Line',
  Wifi2Line: 'Wifi2Line',
  Wifi3Line: 'Wifi3Line',
  Wifi4Line: 'Wifi4Line',
  WifiErrorLine: 'WifiErrorLine',
  WifiOffLine: 'WifiOffLine',
  WineFill: 'WineFill',
  WineLine: 'WineLine',
  ZoomInFill: 'ZoomInFill',
  ZoomInLine: 'ZoomInLine',
  ZoomOutFill: 'ZoomOutFill',
  ZoomOutLine: 'ZoomOutLine',
  AlcoholLine: 'AlcoholLine',
  CallCustomerFill: 'CallCustomerFill',
  CallCustomerLine: 'CallCustomerLine',
  CallCustomer: 'CallCustomer',
  CallDasherFill: 'CallDasherFill',
  CallDasherLine: 'CallDasherLine',
  CallDasher: 'CallDasher',
  CallMerchantFill: 'CallMerchantFill',
  CallMerchantLine: 'CallMerchantLine',
  CallMerchant: 'CallMerchant',
  CallOfficeFill: 'CallOfficeFill',
  CallOfficeLine: 'CallOfficeLine',
  CallOffice: 'CallOffice',
  ChatConversation: 'ChatConversation',
  ChatCustomer: 'ChatCustomer',
  ChatDasher: 'ChatDasher',
  ChatMerchant: 'ChatMerchant',
  ChatOffice: 'ChatOffice'
};
exports.availableTypes = availableTypes;
var availableAssets = {
  '16Add': '16-add.svg',
  '16AddCircleFill': '16-add-circle-fill.svg',
  '16AddCircleLine': '16-add-circle-line.svg',
  '16AddSquareFill': '16-add-square-fill.svg',
  '16AddSquareLine': '16-add-square-line.svg',
  '16ArrowDoubleDown': '16-arrow-double-down.svg',
  '16ArrowDoubleDownLeft': '16-arrow-double-down-left.svg',
  '16ArrowDoubleDownRight': '16-arrow-double-down-right.svg',
  '16ArrowDoubleLeft': '16-arrow-double-left.svg',
  '16ArrowDoubleRight': '16-arrow-double-right.svg',
  '16ArrowDoubleUp': '16-arrow-double-up.svg',
  '16ArrowDoubleUpLeft': '16-arrow-double-up-left.svg',
  '16ArrowDoubleUpRight': '16-arrow-double-up-right.svg',
  '16ArrowDown': '16-arrow-down.svg',
  '16ArrowDownLeft': '16-arrow-down-left.svg',
  '16ArrowDownRight': '16-arrow-down-right.svg',
  '16ArrowLeft': '16-arrow-left.svg',
  '16ArrowRight': '16-arrow-right.svg',
  '16ArrowUp': '16-arrow-up.svg',
  '16ArrowUpLeft': '16-arrow-up-left.svg',
  '16ArrowUpRight': '16-arrow-up-right.svg',
  '16BlobAlmondblob': '16-blob-almondblob.svg',
  '16BlobAvoblob': '16-blob-avoblob.svg',
  '16BlobMusselblob': '16-blob-musselblob.svg',
  '16BlobPearblob': '16-blob-pearblob.svg',
  '16BlobRibsblob': '16-blob-ribsblob.svg',
  '16BlobSteakblob': '16-blob-steakblob.svg',
  '16BoltFill': '16-bolt-fill.svg',
  '16BoltLine': '16-bolt-line.svg',
  '16BookmarkFill': '16-bookmark-fill.svg',
  '16BookmarkFillLight': '16-bookmark-fill-light.svg',
  '16BookmarkLine': '16-bookmark-line.svg',
  '16BookmarkLineLight': '16-bookmark-line-light.svg',
  '16BrowseFill': '16-browse-fill.svg',
  '16BrowseLine': '16-browse-line.svg',
  '16CalendarAddFill': '16-calendar-add-fill.svg',
  '16CalendarAddLine': '16-calendar-add-line.svg',
  '16CalendarCancelFill': '16-calendar-cancel-fill.svg',
  '16CalendarCancelLine': '16-calendar-cancel-line.svg',
  '16CalendarCheckFill': '16-calendar-check-fill.svg',
  '16CalendarCheckLine': '16-calendar-check-line.svg',
  '16CalendarFill': '16-calendar-fill.svg',
  '16CalendarLine': '16-calendar-line.svg',
  '16CameraFill': '16-camera-fill.svg',
  '16CameraLine': '16-camera-line.svg',
  '16CardAmexColor': '16-card-amex-color.svg',
  '16CardAmexMonocolor': '16-card-amex-monocolor.svg',
  '16CardApplePayColor': '16-card-apple-pay-color.svg',
  '16CardApplePayMonocolor': '16-card-apple-pay-monocolor.svg',
  '16CardCaviarColor': '16-card-caviar-color.svg',
  '16CardCaviarMonocolor': '16-card-caviar-monocolor.svg',
  '16CardChaseColor': '16-card-chase-color.svg',
  '16CardChaseMonocolor': '16-card-chase-monocolor.svg',
  '16CardDinersClubColor': '16-card-diners-club-color.svg',
  '16CardDinersClubMonocolor': '16-card-diners-club-monocolor.svg',
  '16CardDiscoverColor': '16-card-discover-color.svg',
  '16CardDiscoverMonocolor': '16-card-discover-monocolor.svg',
  '16CardDoordashColor': '16-card-doordash-color.svg',
  '16CardDoordashMonocolor': '16-card-doordash-monocolor.svg',
  '16CardFill': '16-card-fill.svg',
  '16CardGooglePayColor': '16-card-google-pay-color.svg',
  '16CardGooglePayMonocolor': '16-card-google-pay-monocolor.svg',
  '16CardIdFill': '16-card-id-fill.svg',
  '16CardIdLine': '16-card-id-line.svg',
  '16CardLine': '16-card-line.svg',
  '16CardLoyaltyFill': '16-card-loyalty-fill.svg',
  '16CardLoyaltyLine': '16-card-loyalty-line.svg',
  '16CardMastercardColor': '16-card-mastercard-color.svg',
  '16CardMastercardMonocolor': '16-card-mastercard-monocolor.svg',
  '16CardPaypalColor': '16-card-paypal-color.svg',
  '16CardPaypalMonocolor': '16-card-paypal-monocolor.svg',
  '16CardVenmoColor': '16-card-venmo-color.svg',
  '16CardVenmoMonocolor': '16-card-venmo-monocolor.svg',
  '16CardVisaColor': '16-card-visa-color.svg',
  '16CardVisaMonocolor': '16-card-visa-monocolor.svg',
  '16CaretDown': '16-caret-down.svg',
  '16CaretLeft': '16-caret-left.svg',
  '16CaretRight': '16-caret-right.svg',
  '16CaretUp': '16-caret-up.svg',
  '16CartFill': '16-cart-fill.svg',
  '16CartLine': '16-cart-line.svg',
  '16CateringFill': '16-catering-fill.svg',
  '16CateringLine': '16-catering-line.svg',
  '16Caviar': '16-caviar.svg',
  '16Challenge': '16-challenge.svg',
  '16ChatDefaultFill': '16-chat-default-fill.svg',
  '16ChatDefaultLine': '16-chat-default-line.svg',
  '16Check': '16-check.svg',
  '16CheckCircleFill': '16-check-circle-fill.svg',
  '16CheckCircleLine': '16-check-circle-line.svg',
  '16CheckSquareFill': '16-check-square-fill.svg',
  '16CheckSquareLine': '16-check-square-line.svg',
  '16CheckSquareOffLine': '16-check-square-off-line.svg',
  '16ChevronDoubleDown': '16-chevron-double-down.svg',
  '16ChevronDoubleLeft': '16-chevron-double-left.svg',
  '16ChevronDoubleRight': '16-chevron-double-right.svg',
  '16ChevronDoubleUp': '16-chevron-double-up.svg',
  '16ChevronDown': '16-chevron-down.svg',
  '16ChevronLeft': '16-chevron-left.svg',
  '16ChevronRight': '16-chevron-right.svg',
  '16ChevronUp': '16-chevron-up.svg',
  '16Close': '16-close.svg',
  '16CloseCircleFill': '16-close-circle-fill.svg',
  '16CloseCircleLine': '16-close-circle-line.svg',
  '16CloseSquareFill': '16-close-square-fill.svg',
  '16CloseSquareLine': '16-close-square-line.svg',
  '16Code': '16-code.svg',
  '16CoffeeFill': '16-coffee-fill.svg',
  '16CoffeeLine': '16-coffee-line.svg',
  '16CookingFill': '16-cooking-fill.svg',
  '16CookingLine': '16-cooking-line.svg',
  '16CopyFill': '16-copy-fill.svg',
  '16CopyLine': '16-copy-line.svg',
  '16DashboardFill': '16-dashboard-fill.svg',
  '16DashboardLine': '16-dashboard-line.svg',
  '16DealsFill': '16-deals-fill.svg',
  '16DealsLine': '16-deals-line.svg',
  '16DeliveryTruckFill': '16-delivery-truck-fill.svg',
  '16DeliveryTruckLine': '16-delivery-truck-line.svg',
  '16DevicePhone': '16-device-phone.svg',
  '16DevicePosFill': '16-device-pos-fill.svg',
  '16DevicePosLine': '16-device-pos-line.svg',
  '16DeviceTablet': '16-device-tablet.svg',
  '16DirectionsFill': '16-directions-fill.svg',
  '16DirectionsLine': '16-directions-line.svg',
  '16DockDownLeftLine': '16-dock-down-left-line.svg',
  '16DockDownRightLine': '16-dock-down-right-line.svg',
  '16DockLeftFill': '16-dock-left-fill.svg',
  '16DockLeftLine': '16-dock-left-line.svg',
  '16DockRightFill': '16-dock-right-fill.svg',
  '16DockRightLine': '16-dock-right-line.svg',
  '16DockUpLeftLine': '16-dock-up-left-line.svg',
  '16DockUpRightLine': '16-dock-up-right-line.svg',
  '16DownloadFill': '16-download-fill.svg',
  '16DownloadLine': '16-download-line.svg',
  '16EditAddFill': '16-edit-add-fill.svg',
  '16EditAddLine': '16-edit-add-line.svg',
  '16EditFill': '16-edit-fill.svg',
  '16EditLine': '16-edit-line.svg',
  '16EmailFill': '16-email-fill.svg',
  '16EmailLine': '16-email-line.svg',
  '16ErrorFill': '16-error-fill.svg',
  '16ErrorLine': '16-error-line.svg',
  '16EyeHiddenFill': '16-eye-hidden-fill.svg',
  '16EyeHiddenLine': '16-eye-hidden-line.svg',
  '16EyeVisibleFill': '16-eye-visible-fill.svg',
  '16EyeVisibleLine': '16-eye-visible-line.svg',
  '16FavoriteFill': '16-favorite-fill.svg',
  '16FavoriteFillLight': '16-favorite-fill-light.svg',
  '16FavoriteLine': '16-favorite-line.svg',
  '16FavoriteLineLight': '16-favorite-line-light.svg',
  '16FaxFill': '16-fax-fill.svg',
  '16FaxLine': '16-fax-line.svg',
  '16FigmaFill': '16-figma-fill.svg',
  '16FigmaLine': '16-figma-line.svg',
  '16FilterFill': '16-filter-fill.svg',
  '16FilterLine': '16-filter-line.svg',
  '16FlagFill': '16-flag-fill.svg',
  '16FlagLine': '16-flag-line.svg',
  '16FlowerFill': '16-flower-fill.svg',
  '16FlowerLine': '16-flower-line.svg',
  '16FoodBowlFill': '16-food-bowl-fill.svg',
  '16FoodBowlLine': '16-food-bowl-line.svg',
  '16FoodLine': '16-food-line.svg',
  '16FunnelFill': '16-funnel-fill.svg',
  '16FunnelLine': '16-funnel-line.svg',
  '16GiftFill': '16-gift-fill.svg',
  '16GiftLine': '16-gift-line.svg',
  '16GlobeFill': '16-globe-fill.svg',
  '16GlobeLine': '16-globe-line.svg',
  '16HalfFill': '16-half-fill.svg',
  '16HalfLine': '16-half-line.svg',
  '16HelpCircleFill': '16-help-circle-fill.svg',
  '16HelpCircleLine': '16-help-circle-line.svg',
  '16HelpLifesaver': '16-help-lifesaver.svg',
  '16HomeFill': '16-home-fill.svg',
  '16HomeLine': '16-home-line.svg',
  '16InfoCircleFill': '16-info-circle-fill.svg',
  '16InfoCircleLine': '16-info-circle-line.svg',
  '16InfoFill': '16-info-fill.svg',
  '16InfoLine': '16-info-line.svg',
  '16InsightFill': '16-insight-fill.svg',
  '16InsightLine': '16-insight-line.svg',
  '16KeyFill': '16-key-fill.svg',
  '16KeyLine': '16-key-line.svg',
  '16Link': '16-link.svg',
  '16LinkBroken': '16-link-broken.svg',
  '16LinkExternalFill': '16-link-external-fill.svg',
  '16LinkExternalLine': '16-link-external-line.svg',
  '16List': '16-list.svg',
  '16LocationGpsFill': '16-location-gps-fill.svg',
  '16LocationGpsLine': '16-location-gps-line.svg',
  '16LocationPinDisabledFill': '16-location-pin-disabled-fill.svg',
  '16LocationPinDisabledLine': '16-location-pin-disabled-line.svg',
  '16LocationPinEnabledFill': '16-location-pin-enabled-fill.svg',
  '16LocationPinEnabledLine': '16-location-pin-enabled-line.svg',
  '16LocationPointerFill': '16-location-pointer-fill.svg',
  '16LocationPointerLine': '16-location-pointer-line.svg',
  '16LockedFill': '16-locked-fill.svg',
  '16LockedLine': '16-locked-line.svg',
  '16LogoAdtColor': '16-logo-adt-color.svg',
  '16LogoAdtMonocolor': '16-logo-adt-monocolor.svg',
  '16LogoAfterpay': '16-logo-afterpay.svg',
  '16LogoAfterpayColor': '16-logo-afterpay-color.svg',
  '16LogoAfterpayMonocolor': '16-logo-afterpay-monocolor.svg',
  '16LogoAndroid': '16-logo-android.svg',
  '16LogoApple': '16-logo-apple.svg',
  '16LogoChase': '16-logo-chase.svg',
  '16LogoCheckrColor': '16-logo-checkr-color.svg',
  '16LogoCheckrMonocolor': '16-logo-checkr-monocolor.svg',
  '16LogoDashpass': '16-logo-dashpass.svg',
  '16LogoDashpassMonocolor': '16-logo-dashpass-monocolor.svg',
  '16LogoDashpassNew': '16-logo-dashpass-new.svg',
  '16LogoDoordash': '16-logo-doordash.svg',
  '16LogoFacebook': '16-logo-facebook.svg',
  '16LogoGithubColor': '16-logo-github-color.svg',
  '16LogoGithubMonocolor': '16-logo-github-monocolor.svg',
  '16LogoGlassdoor': '16-logo-glassdoor.svg',
  '16LogoGoogle': '16-logo-google.svg',
  '16LogoInstagram': '16-logo-instagram.svg',
  '16LogoLineColor': '16-logo-line-color.svg',
  '16LogoLineMonocolor': '16-logo-line-monocolor.svg',
  '16LogoLinkedin': '16-logo-linkedin.svg',
  '16LogoMedium': '16-logo-medium.svg',
  '16LogoPaypayColor': '16-logo-paypay-color.svg',
  '16LogoPaypayMonocolor': '16-logo-paypay-monocolor.svg',
  '16LogoSiftColor': '16-logo-sift-color.svg',
  '16LogoSiftMonocolor': '16-logo-sift-monocolor.svg',
  '16LogoSquare': '16-logo-square.svg',
  '16LogoStripeColor': '16-logo-stripe-color.svg',
  '16LogoStripeMonocolor': '16-logo-stripe-monocolor.svg',
  '16LogoTwitter': '16-logo-twitter.svg',
  '16LogoVenmo': '16-logo-venmo.svg',
  '16LogoWebhooks': '16-logo-webhooks.svg',
  '16LogoutFill': '16-logout-fill.svg',
  '16LogoutLine': '16-logout-line.svg',
  '16MapFill': '16-map-fill.svg',
  '16MapLine': '16-map-line.svg',
  '16MaskFill': '16-mask-fill.svg',
  '16MaskLine': '16-mask-line.svg',
  '16Menu': '16-menu.svg',
  '16MenuEditFill': '16-menu-edit-fill.svg',
  '16MenuEditLine': '16-menu-edit-line.svg',
  '16MenuShare': '16-menu-share.svg',
  '16MerchantDisabledFill': '16-merchant-disabled-fill.svg',
  '16MerchantDisabledLine': '16-merchant-disabled-line.svg',
  '16MerchantFill': '16-merchant-fill.svg',
  '16MerchantLine': '16-merchant-line.svg',
  '16MicrophoneFill': '16-microphone-fill.svg',
  '16MicrophoneLine': '16-microphone-line.svg',
  '16MoneyBank': '16-money-bank.svg',
  '16MoneyCircleDisabledFill': '16-money-circle-disabled-fill.svg',
  '16MoneyCircleDisabledLine': '16-money-circle-disabled-line.svg',
  '16MoneyCircleEnabledFill': '16-money-circle-enabled-fill.svg',
  '16MoneyCircleEnabledLine': '16-money-circle-enabled-line.svg',
  '16MoneyCircleFill': '16-money-circle-fill.svg',
  '16MoneyCircleLine': '16-money-circle-line.svg',
  '16MoneyDefault': '16-money-default.svg',
  '16MoneyEuro': '16-money-euro.svg',
  '16MoneyEuroCircleDisabledFill': '16-money-euro-circle-disabled-fill.svg',
  '16MoneyEuroCircleDisabledLine': '16-money-euro-circle-disabled-line.svg',
  '16MoneyEuroCircleEnabledFill': '16-money-euro-circle-enabled-fill.svg',
  '16MoneyEuroCircleEnabledLine': '16-money-euro-circle-enabled-line.svg',
  '16MoneyYen': '16-money-yen.svg',
  '16MoneyYenCircleDisabledFill': '16-money-yen-circle-disabled-fill.svg',
  '16MoneyYenCircleDisabledLine': '16-money-yen-circle-disabled-line.svg',
  '16MoneyYenCircleEnabledFill': '16-money-yen-circle-enabled-fill.svg',
  '16MoneyYenCircleEnabledLine': '16-money-yen-circle-enabled-line.svg',
  '16MoreHorizontal': '16-more-horizontal.svg',
  '16MoreVertical': '16-more-vertical.svg',
  '16NotifyFill': '16-notify-fill.svg',
  '16NotifyLine': '16-notify-line.svg',
  '16Number1Fill': '16-number-1-fill.svg',
  '16Number1Line': '16-number-1-line.svg',
  '16Number2Fill': '16-number-2-fill.svg',
  '16Number2Line': '16-number-2-line.svg',
  '16Number3Fill': '16-number-3-fill.svg',
  '16Number3Line': '16-number-3-line.svg',
  '16Number4Fill': '16-number-4-fill.svg',
  '16Number4Line': '16-number-4-line.svg',
  '16Number5Fill': '16-number-5-fill.svg',
  '16Number5Line': '16-number-5-line.svg',
  '16Number6Fill': '16-number-6-fill.svg',
  '16Number6Line': '16-number-6-line.svg',
  '16Number7Fill': '16-number-7-fill.svg',
  '16Number7Line': '16-number-7-line.svg',
  '16Number8Fill': '16-number-8-fill.svg',
  '16Number8Line': '16-number-8-line.svg',
  '16Number9Fill': '16-number-9-fill.svg',
  '16Number9Line': '16-number-9-line.svg',
  '16Office': '16-office.svg',
  '16OrderBagFill': '16-order-bag-fill.svg',
  '16OrderBagLine': '16-order-bag-line.svg',
  '16OrderBatchFill': '16-order-batch-fill.svg',
  '16OrderBatchLine': '16-order-batch-line.svg',
  '16OrderHotbagFill': '16-order-hotbag-fill.svg',
  '16OrderHotbagLine': '16-order-hotbag-line.svg',
  '16OrderIncorrectFill': '16-order-incorrect-fill.svg',
  '16OrderIncorrectLine': '16-order-incorrect-line.svg',
  '16OrderLargeFill': '16-order-large-fill.svg',
  '16OrderLargeFillFrCa': '16-order-large-fill-fr-ca.svg',
  '16OrderLargeLine': '16-order-large-line.svg',
  '16OrderLargeLineFrCa': '16-order-large-line-fr-ca.svg',
  '16OrderMediumFill': '16-order-medium-fill.svg',
  '16OrderMediumFillFrCa': '16-order-medium-fill-fr-ca.svg',
  '16OrderMediumLine': '16-order-medium-line.svg',
  '16OrderMediumLineFrCa': '16-order-medium-line-fr-ca.svg',
  '16OrderProtocol': '16-order-protocol.svg',
  '16OrderSmallFill': '16-order-small-fill.svg',
  '16OrderSmallFillFrCa': '16-order-small-fill-fr-ca.svg',
  '16OrderSmallLine': '16-order-small-line.svg',
  '16OrderSmallLineFrCa': '16-order-small-line-fr-ca.svg',
  '16ParkingEsMxFill': '16-parking-es-mx-fill.svg',
  '16ParkingEsMxLine': '16-parking-es-mx-line.svg',
  '16ParkingFill': '16-parking-fill.svg',
  '16ParkingLine': '16-parking-line.svg',
  '16PauseFill': '16-pause-fill.svg',
  '16PauseLine': '16-pause-line.svg',
  '16PaymentFill': '16-payment-fill.svg',
  '16PaymentLine': '16-payment-line.svg',
  '16PeopleAddFill': '16-people-add-fill.svg',
  '16PeopleAddLine': '16-people-add-line.svg',
  '16PeopleGroupFill': '16-people-group-fill.svg',
  '16PeopleGroupLine': '16-people-group-line.svg',
  '16PersonFindFill': '16-person-find-fill.svg',
  '16PersonFindLine': '16-person-find-line.svg',
  '16PersonProfileFill': '16-person-profile-fill.svg',
  '16PersonProfileLine': '16-person-profile-line.svg',
  '16PersonUserFill': '16-person-user-fill.svg',
  '16PersonUserLine': '16-person-user-line.svg',
  '16PetsFill': '16-pets-fill.svg',
  '16PetsLine': '16-pets-line.svg',
  '16PharmacyFill': '16-pharmacy-fill.svg',
  '16PharmacyLine': '16-pharmacy-line.svg',
  '16PhoneCallFill': '16-phone-call-fill.svg',
  '16PhoneCallLine': '16-phone-call-line.svg',
  '16PhotoFill': '16-photo-fill.svg',
  '16PhotoFlipFill': '16-photo-flip-fill.svg',
  '16PhotoFlipLine': '16-photo-flip-line.svg',
  '16PhotoLine': '16-photo-line.svg',
  '16PhotoRotateFill': '16-photo-rotate-fill.svg',
  '16PhotoRotateLine': '16-photo-rotate-line.svg',
  '16PhotoUploadFill': '16-photo-upload-fill.svg',
  '16PhotoUploadLine': '16-photo-upload-line.svg',
  '16PhotosFill': '16-photos-fill.svg',
  '16PhotosLine': '16-photos-line.svg',
  '16PlayFill': '16-play-fill.svg',
  '16PlayLine': '16-play-line.svg',
  '16PluginFill': '16-plugin-fill.svg',
  '16PluginLine': '16-plugin-line.svg',
  '16PrintFill': '16-print-fill.svg',
  '16PrintLine': '16-print-line.svg',
  '16PrismFill': '16-prism-fill.svg',
  '16PrismLine': '16-prism-line.svg',
  '16ProhibitedFill': '16-prohibited-fill.svg',
  '16ProhibitedLine': '16-prohibited-line.svg',
  '16PromoBullhornFill': '16-promo-bullhorn-fill.svg',
  '16PromoBullhornLine': '16-promo-bullhorn-line.svg',
  '16PromoFill': '16-promo-fill.svg',
  '16PromoLine': '16-promo-line.svg',
  '16RadioOffCircleLine': '16-radio-off-circle-line.svg',
  '16RadioOnCircleFill': '16-radio-on-circle-fill.svg',
  '16RearrangeVertical': '16-rearrange-vertical.svg',
  '16ReceiptCancelOrderFill': '16-receipt-cancel-order-fill.svg',
  '16ReceiptCancelOrderLine': '16-receipt-cancel-order-line.svg',
  '16ReceiptFill': '16-receipt-fill.svg',
  '16ReceiptLine': '16-receipt-line.svg',
  '16RefundFill': '16-refund-fill.svg',
  '16RefundLine': '16-refund-line.svg',
  '16RewardFill': '16-reward-fill.svg',
  '16RewardLine': '16-reward-line.svg',
  '16RobotFill': '16-robot-fill.svg',
  '16RobotLine': '16-robot-line.svg',
  '16Rotate': '16-rotate.svg',
  '16RunTest': '16-run-test.svg',
  '16RunTestFill': '16-run-test-fill.svg',
  '16SafetyFill': '16-safety-fill.svg',
  '16SafetyLine': '16-safety-line.svg',
  '16SatelliteFill': '16-satellite-fill.svg',
  '16SatelliteLine': '16-satellite-line.svg',
  '16Scan': '16-scan.svg',
  '16Search': '16-search.svg',
  '16SearchFill': '16-search-fill.svg',
  '16SearchLine': '16-search-line.svg',
  '16Send': '16-send.svg',
  '16SendFill': '16-send-fill.svg',
  '16SendLine': '16-send-line.svg',
  '16SettingsFill': '16-settings-fill.svg',
  '16SettingsLine': '16-settings-line.svg',
  '16ShareFill': '16-share-fill.svg',
  '16ShareLine': '16-share-line.svg',
  '16SignalHigh': '16-signal-high.svg',
  '16SignalLow': '16-signal-low.svg',
  '16SignalMedium': '16-signal-medium.svg',
  '16SkewHorizontalFill': '16-skew-horizontal-fill.svg',
  '16SkewHorizontalLine': '16-skew-horizontal-line.svg',
  '16SkewVerticalFill': '16-skew-vertical-fill.svg',
  '16SkewVerticalLine': '16-skew-vertical-line.svg',
  '16SmileyHappyFill': '16-smiley-happy-fill.svg',
  '16SmileyHappyLine': '16-smiley-happy-line.svg',
  '16SmileyNeutralFill': '16-smiley-neutral-fill.svg',
  '16SmileyNeutralLine': '16-smiley-neutral-line.svg',
  '16SmileySadFill': '16-smiley-sad-fill.svg',
  '16SmileySadLine': '16-smiley-sad-line.svg',
  '16Sort': '16-sort.svg',
  '16SortOrder': '16-sort-order.svg',
  '16Sos': '16-sos.svg',
  '16SpellingFill': '16-spelling-fill.svg',
  '16SpellingLine': '16-spelling-line.svg',
  '16StarFill': '16-star-fill.svg',
  '16StarHalf': '16-star-half.svg',
  '16StarLine': '16-star-line.svg',
  '16Subtract': '16-subtract.svg',
  '16SubtractCircleFill': '16-subtract-circle-fill.svg',
  '16SubtractCircleLine': '16-subtract-circle-line.svg',
  '16SubtractSquareFill': '16-subtract-square-fill.svg',
  '16SubtractSquareLine': '16-subtract-square-line.svg',
  '16Swap': '16-swap.svg',
  '16SwapCircleFill': '16-swap-circle-fill.svg',
  '16SwapCircleLine': '16-swap-circle-line.svg',
  '16Sync': '16-sync.svg',
  '16ThumbsDownFill': '16-thumbs-down-fill.svg',
  '16ThumbsDownLine': '16-thumbs-down-line.svg',
  '16ThumbsUpFill': '16-thumbs-up-fill.svg',
  '16ThumbsUpLine': '16-thumbs-up-line.svg',
  '16TimeFill': '16-time-fill.svg',
  '16TimeLine': '16-time-line.svg',
  '16TippingFill': '16-tipping-fill.svg',
  '16TippingLine': '16-tipping-line.svg',
  '16TipsStaffFill': '16-tips-staff-fill.svg',
  '16TipsStaffLine': '16-tips-staff-line.svg',
  '16ToteFill': '16-tote-fill.svg',
  '16ToteLine': '16-tote-line.svg',
  '16TrashFill': '16-trash-fill.svg',
  '16TrashLine': '16-trash-line.svg',
  '16TrashRestoreFill': '16-trash-restore-fill.svg',
  '16TrashRestoreLine': '16-trash-restore-line.svg',
  '16TrendDownCaret': '16-trend-down-caret.svg',
  '16TrendUpCaret': '16-trend-up-caret.svg',
  '16UnlockedFill': '16-unlocked-fill.svg',
  '16UnlockedLine': '16-unlocked-line.svg',
  '16UploadFill': '16-upload-fill.svg',
  '16UploadLine': '16-upload-line.svg',
  '16VehicleAirplane': '16-vehicle-airplane.svg',
  '16VehicleBikeFill': '16-vehicle-bike-fill.svg',
  '16VehicleBikeLine': '16-vehicle-bike-line.svg',
  '16VehicleCar': '16-vehicle-car.svg',
  '16VehicleEbikeFill': '16-vehicle-ebike-fill.svg',
  '16VehicleEbikeLine': '16-vehicle-ebike-line.svg',
  '16VehicleMotorcycleFill': '16-vehicle-motorcycle-fill.svg',
  '16VehicleMotorcycleLine': '16-vehicle-motorcycle-line.svg',
  '16VehicleScooterFill': '16-vehicle-scooter-fill.svg',
  '16VehicleScooterLine': '16-vehicle-scooter-line.svg',
  '16VehicleWalk': '16-vehicle-walk.svg',
  '16ViewCollapse': '16-view-collapse.svg',
  '16ViewExpand': '16-view-expand.svg',
  '16VolumeHighFill': '16-volume-high-fill.svg',
  '16VolumeHighLine': '16-volume-high-line.svg',
  '16VolumeLowFill': '16-volume-low-fill.svg',
  '16VolumeLowLine': '16-volume-low-line.svg',
  '16VolumeMuteFill': '16-volume-mute-fill.svg',
  '16VolumeMuteLine': '16-volume-mute-line.svg',
  '16VolumeNoneFill': '16-volume-none-fill.svg',
  '16VolumeNoneLine': '16-volume-none-line.svg',
  '16WarningCircleFill': '16-warning-circle-fill.svg',
  '16WarningCircleLine': '16-warning-circle-line.svg',
  '16WarningFill': '16-warning-fill.svg',
  '16WarningLine': '16-warning-line.svg',
  '16WarningTriangleFill': '16-warning-triangle-fill.svg',
  '16WarningTriangleLine': '16-warning-triangle-line.svg',
  '16Wifi0Line': '16-wifi-0-line.svg',
  '16Wifi1Line': '16-wifi-1-line.svg',
  '16Wifi2Line': '16-wifi-2-line.svg',
  '16Wifi3Line': '16-wifi-3-line.svg',
  '16Wifi4Line': '16-wifi-4-line.svg',
  '16WifiErrorLine': '16-wifi-error-line.svg',
  '16WifiOffLine': '16-wifi-off-line.svg',
  '16WineFill': '16-wine-fill.svg',
  '16WineLine': '16-wine-line.svg',
  '16ZoomInFill': '16-zoom-in-fill.svg',
  '16ZoomInLine': '16-zoom-in-line.svg',
  '16ZoomOutFill': '16-zoom-out-fill.svg',
  '16ZoomOutLine': '16-zoom-out-line.svg',
  '24Add': '24-add.svg',
  '24AddCircleFill': '24-add-circle-fill.svg',
  '24AddCircleLine': '24-add-circle-line.svg',
  '24AddSquareFill': '24-add-square-fill.svg',
  '24AddSquareLine': '24-add-square-line.svg',
  '24AlcoholLine': '24-alcohol-line.svg',
  '24ArrowDoubleDown': '24-arrow-double-down.svg',
  '24ArrowDoubleDownLeft': '24-arrow-double-down-left.svg',
  '24ArrowDoubleDownRight': '24-arrow-double-down-right.svg',
  '24ArrowDoubleLeft': '24-arrow-double-left.svg',
  '24ArrowDoubleRight': '24-arrow-double-right.svg',
  '24ArrowDoubleUp': '24-arrow-double-up.svg',
  '24ArrowDoubleUpLeft': '24-arrow-double-up-left.svg',
  '24ArrowDoubleUpRight': '24-arrow-double-up-right.svg',
  '24ArrowDown': '24-arrow-down.svg',
  '24ArrowDownLeft': '24-arrow-down-left.svg',
  '24ArrowDownRight': '24-arrow-down-right.svg',
  '24ArrowLeft': '24-arrow-left.svg',
  '24ArrowRight': '24-arrow-right.svg',
  '24ArrowUp': '24-arrow-up.svg',
  '24ArrowUpLeft': '24-arrow-up-left.svg',
  '24ArrowUpRight': '24-arrow-up-right.svg',
  '24BlobAlmondblob': '24-blob-almondblob.svg',
  '24BlobAvoblob': '24-blob-avoblob.svg',
  '24BlobMusselblob': '24-blob-musselblob.svg',
  '24BlobPearblob': '24-blob-pearblob.svg',
  '24BlobRibsblob': '24-blob-ribsblob.svg',
  '24BlobSteakblob': '24-blob-steakblob.svg',
  '24BoltFill': '24-bolt-fill.svg',
  '24BoltLine': '24-bolt-line.svg',
  '24BookmarkFill': '24-bookmark-fill.svg',
  '24BookmarkFillLight': '24-bookmark-fill-light.svg',
  '24BookmarkLine': '24-bookmark-line.svg',
  '24BookmarkLineLight': '24-bookmark-line-light.svg',
  '24BrowseFill': '24-browse-fill.svg',
  '24BrowseLine': '24-browse-line.svg',
  '24CalendarAddFill': '24-calendar-add-fill.svg',
  '24CalendarAddLine': '24-calendar-add-line.svg',
  '24CalendarCancelFill': '24-calendar-cancel-fill.svg',
  '24CalendarCancelLine': '24-calendar-cancel-line.svg',
  '24CalendarCheckFill': '24-calendar-check-fill.svg',
  '24CalendarCheckLine': '24-calendar-check-line.svg',
  '24CalendarFill': '24-calendar-fill.svg',
  '24CalendarLine': '24-calendar-line.svg',
  '24CallCustomer': '24-call-customer.svg',
  '24CallCustomerFill': '24-call-customer-fill.svg',
  '24CallCustomerLine': '24-call-customer-line.svg',
  '24CallDasher': '24-call-dasher.svg',
  '24CallDasherFill': '24-call-dasher-fill.svg',
  '24CallDasherLine': '24-call-dasher-line.svg',
  '24CallMerchant': '24-call-merchant.svg',
  '24CallMerchantFill': '24-call-merchant-fill.svg',
  '24CallMerchantLine': '24-call-merchant-line.svg',
  '24CallOffice': '24-call-office.svg',
  '24CallOfficeFill': '24-call-office-fill.svg',
  '24CallOfficeLine': '24-call-office-line.svg',
  '24CameraFill': '24-camera-fill.svg',
  '24CameraLine': '24-camera-line.svg',
  '24CardAmexColor': '24-card-amex-color.svg',
  '24CardAmexMonocolor': '24-card-amex-monocolor.svg',
  '24CardApplePayColor': '24-card-apple-pay-color.svg',
  '24CardApplePayMonocolor': '24-card-apple-pay-monocolor.svg',
  '24CardCaviarColor': '24-card-caviar-color.svg',
  '24CardCaviarMonocolor': '24-card-caviar-monocolor.svg',
  '24CardChaseColor': '24-card-chase-color.svg',
  '24CardChaseMonocolor': '24-card-chase-monocolor.svg',
  '24CardDinersClubColor': '24-card-diners-club-color.svg',
  '24CardDinersClubMonocolor': '24-card-diners-club-monocolor.svg',
  '24CardDiscoverColor': '24-card-discover-color.svg',
  '24CardDiscoverMonocolor': '24-card-discover-monocolor.svg',
  '24CardDoordashColor': '24-card-doordash-color.svg',
  '24CardDoordashMonocolor': '24-card-doordash-monocolor.svg',
  '24CardFill': '24-card-fill.svg',
  '24CardGooglePayColor': '24-card-google-pay-color.svg',
  '24CardGooglePayMonocolor': '24-card-google-pay-monocolor.svg',
  '24CardIdFill': '24-card-id-fill.svg',
  '24CardIdLine': '24-card-id-line.svg',
  '24CardLine': '24-card-line.svg',
  '24CardLoyaltyFill': '24-card-loyalty-fill.svg',
  '24CardLoyaltyLine': '24-card-loyalty-line.svg',
  '24CardMastercardColor': '24-card-mastercard-color.svg',
  '24CardMastercardMonocolor': '24-card-mastercard-monocolor.svg',
  '24CardPaypalColor': '24-card-paypal-color.svg',
  '24CardPaypalMonocolor': '24-card-paypal-monocolor.svg',
  '24CardVenmoColor': '24-card-venmo-color.svg',
  '24CardVenmoMonocolor': '24-card-venmo-monocolor.svg',
  '24CardVisaColor': '24-card-visa-color.svg',
  '24CardVisaMonocolor': '24-card-visa-monocolor.svg',
  '24CaretDown': '24-caret-down.svg',
  '24CaretLeft': '24-caret-left.svg',
  '24CaretRight': '24-caret-right.svg',
  '24CaretUp': '24-caret-up.svg',
  '24CartFill': '24-cart-fill.svg',
  '24CartLine': '24-cart-line.svg',
  '24CateringFill': '24-catering-fill.svg',
  '24CateringLine': '24-catering-line.svg',
  '24Caviar': '24-caviar.svg',
  '24Challenge': '24-challenge.svg',
  '24ChatConversation': '24-chat-conversation.svg',
  '24ChatCustomer': '24-chat-customer.svg',
  '24ChatDasher': '24-chat-dasher.svg',
  '24ChatDefaultFill': '24-chat-default-fill.svg',
  '24ChatDefaultLine': '24-chat-default-line.svg',
  '24ChatMerchant': '24-chat-merchant.svg',
  '24ChatOffice': '24-chat-office.svg',
  '24Check': '24-check.svg',
  '24CheckCircleFill': '24-check-circle-fill.svg',
  '24CheckCircleLine': '24-check-circle-line.svg',
  '24CheckSquareFill': '24-check-square-fill.svg',
  '24CheckSquareLine': '24-check-square-line.svg',
  '24CheckSquareOffLine': '24-check-square-off-line.svg',
  '24ChevronDoubleDown': '24-chevron-double-down.svg',
  '24ChevronDoubleLeft': '24-chevron-double-left.svg',
  '24ChevronDoubleRight': '24-chevron-double-right.svg',
  '24ChevronDoubleUp': '24-chevron-double-up.svg',
  '24ChevronDown': '24-chevron-down.svg',
  '24ChevronLeft': '24-chevron-left.svg',
  '24ChevronRight': '24-chevron-right.svg',
  '24ChevronUp': '24-chevron-up.svg',
  '24Close': '24-close.svg',
  '24CloseCircleFill': '24-close-circle-fill.svg',
  '24CloseCircleLine': '24-close-circle-line.svg',
  '24CloseSquareFill': '24-close-square-fill.svg',
  '24CloseSquareLine': '24-close-square-line.svg',
  '24Code': '24-code.svg',
  '24CoffeeFill': '24-coffee-fill.svg',
  '24CoffeeLine': '24-coffee-line.svg',
  '24CookingFill': '24-cooking-fill.svg',
  '24CookingLine': '24-cooking-line.svg',
  '24CopyFill': '24-copy-fill.svg',
  '24CopyLine': '24-copy-line.svg',
  '24DashboardFill': '24-dashboard-fill.svg',
  '24DashboardLine': '24-dashboard-line.svg',
  '24DealsFill': '24-deals-fill.svg',
  '24DealsLine': '24-deals-line.svg',
  '24DeliveryTruckFill': '24-delivery-truck-fill.svg',
  '24DeliveryTruckLine': '24-delivery-truck-line.svg',
  '24DevicePhone': '24-device-phone.svg',
  '24DevicePosFill': '24-device-pos-fill.svg',
  '24DevicePosLine': '24-device-pos-line.svg',
  '24DeviceTablet': '24-device-tablet.svg',
  '24DirectionsFill': '24-directions-fill.svg',
  '24DirectionsLine': '24-directions-line.svg',
  '24DockDownLeftLine': '24-dock-down-left-line.svg',
  '24DockDownRightLine': '24-dock-down-right-line.svg',
  '24DockLeftFill': '24-dock-left-fill.svg',
  '24DockLeftLine': '24-dock-left-line.svg',
  '24DockRightFill': '24-dock-right-fill.svg',
  '24DockRightLine': '24-dock-right-line.svg',
  '24DockUpLeftLine': '24-dock-up-left-line.svg',
  '24DockUpRightLine': '24-dock-up-right-line.svg',
  '24DownloadFill': '24-download-fill.svg',
  '24DownloadLine': '24-download-line.svg',
  '24EditAddFill': '24-edit-add-fill.svg',
  '24EditAddLine': '24-edit-add-line.svg',
  '24EditFill': '24-edit-fill.svg',
  '24EditLine': '24-edit-line.svg',
  '24EmailFill': '24-email-fill.svg',
  '24EmailLine': '24-email-line.svg',
  '24ErrorFill': '24-error-fill.svg',
  '24ErrorLine': '24-error-line.svg',
  '24EyeHiddenFill': '24-eye-hidden-fill.svg',
  '24EyeHiddenLine': '24-eye-hidden-line.svg',
  '24EyeVisibleFill': '24-eye-visible-fill.svg',
  '24EyeVisibleLine': '24-eye-visible-line.svg',
  '24FavoriteFill': '24-favorite-fill.svg',
  '24FavoriteFillLight': '24-favorite-fill-light.svg',
  '24FavoriteLine': '24-favorite-line.svg',
  '24FavoriteLineLight': '24-favorite-line-light.svg',
  '24FaxFill': '24-fax-fill.svg',
  '24FaxLine': '24-fax-line.svg',
  '24FigmaFill': '24-figma-fill.svg',
  '24FigmaLine': '24-figma-line.svg',
  '24FilterFill': '24-filter-fill.svg',
  '24FilterLine': '24-filter-line.svg',
  '24FlagFill': '24-flag-fill.svg',
  '24FlagLine': '24-flag-line.svg',
  '24FlowerFill': '24-flower-fill.svg',
  '24FlowerLine': '24-flower-line.svg',
  '24FoodBowlFill': '24-food-bowl-fill.svg',
  '24FoodBowlLine': '24-food-bowl-line.svg',
  '24FoodLine': '24-food-line.svg',
  '24FunnelFill': '24-funnel-fill.svg',
  '24FunnelLine': '24-funnel-line.svg',
  '24GiftFill': '24-gift-fill.svg',
  '24GiftLine': '24-gift-line.svg',
  '24GlobeFill': '24-globe-fill.svg',
  '24GlobeLine': '24-globe-line.svg',
  '24HalfFill': '24-half-fill.svg',
  '24HalfLine': '24-half-line.svg',
  '24HelpCircleFill': '24-help-circle-fill.svg',
  '24HelpCircleLine': '24-help-circle-line.svg',
  '24HelpLifesaver': '24-help-lifesaver.svg',
  '24HomeFill': '24-home-fill.svg',
  '24HomeLine': '24-home-line.svg',
  '24InfoCircleFill': '24-info-circle-fill.svg',
  '24InfoCircleLine': '24-info-circle-line.svg',
  '24InfoFill': '24-info-fill.svg',
  '24InfoLine': '24-info-line.svg',
  '24InsightFill': '24-insight-fill.svg',
  '24InsightLine': '24-insight-line.svg',
  '24KeyFill': '24-key-fill.svg',
  '24KeyLine': '24-key-line.svg',
  '24Link': '24-link.svg',
  '24LinkBroken': '24-link-broken.svg',
  '24LinkExternalFill': '24-link-external-fill.svg',
  '24LinkExternalLine': '24-link-external-line.svg',
  '24List': '24-list.svg',
  '24LocationGpsFill': '24-location-gps-fill.svg',
  '24LocationGpsLine': '24-location-gps-line.svg',
  '24LocationPinDisabledFill': '24-location-pin-disabled-fill.svg',
  '24LocationPinDisabledLine': '24-location-pin-disabled-line.svg',
  '24LocationPinEnabledFill': '24-location-pin-enabled-fill.svg',
  '24LocationPinEnabledLine': '24-location-pin-enabled-line.svg',
  '24LocationPointerFill': '24-location-pointer-fill.svg',
  '24LocationPointerLine': '24-location-pointer-line.svg',
  '24LockedFill': '24-locked-fill.svg',
  '24LockedLine': '24-locked-line.svg',
  '24LogoAdtColor': '24-logo-adt-color.svg',
  '24LogoAdtMonocolor': '24-logo-adt-monocolor.svg',
  '24LogoAfterpay': '24-logo-afterpay.svg',
  '24LogoAfterpayColor': '24-logo-afterpay-color.svg',
  '24LogoAfterpayMonocolor': '24-logo-afterpay-monocolor.svg',
  '24LogoAndroid': '24-logo-android.svg',
  '24LogoApple': '24-logo-apple.svg',
  '24LogoChase': '24-logo-chase.svg',
  '24LogoCheckrColor': '24-logo-checkr-color.svg',
  '24LogoCheckrMonocolor': '24-logo-checkr-monocolor.svg',
  '24LogoDashpass': '24-logo-dashpass.svg',
  '24LogoDashpassMonocolor': '24-logo-dashpass-monocolor.svg',
  '24LogoDashpassNew': '24-logo-dashpass-new.svg',
  '24LogoDoordash': '24-logo-doordash.svg',
  '24LogoFacebook': '24-logo-facebook.svg',
  '24LogoGithubColor': '24-logo-github-color.svg',
  '24LogoGithubMonocolor': '24-logo-github-monocolor.svg',
  '24LogoGlassdoor': '24-logo-glassdoor.svg',
  '24LogoGoogle': '24-logo-google.svg',
  '24LogoInstagram': '24-logo-instagram.svg',
  '24LogoLineColor': '24-logo-line-color.svg',
  '24LogoLineMonocolor': '24-logo-line-monocolor.svg',
  '24LogoLinkedin': '24-logo-linkedin.svg',
  '24LogoMedium': '24-logo-medium.svg',
  '24LogoPaypayColor': '24-logo-paypay-color.svg',
  '24LogoPaypayMonocolor': '24-logo-paypay-monocolor.svg',
  '24LogoSiftColor': '24-logo-sift-color.svg',
  '24LogoSiftMonocolor': '24-logo-sift-monocolor.svg',
  '24LogoSquare': '24-logo-square.svg',
  '24LogoStripeColor': '24-logo-stripe-color.svg',
  '24LogoStripeMonocolor': '24-logo-stripe-monocolor.svg',
  '24LogoTwitter': '24-logo-twitter.svg',
  '24LogoVenmo': '24-logo-venmo.svg',
  '24LogoWebhooks': '24-logo-webhooks.svg',
  '24LogoutFill': '24-logout-fill.svg',
  '24LogoutLine': '24-logout-line.svg',
  '24MapFill': '24-map-fill.svg',
  '24MapLine': '24-map-line.svg',
  '24MaskFill': '24-mask-fill.svg',
  '24MaskLine': '24-mask-line.svg',
  '24Menu': '24-menu.svg',
  '24MenuEditFill': '24-menu-edit-fill.svg',
  '24MenuEditLine': '24-menu-edit-line.svg',
  '24MenuShare': '24-menu-share.svg',
  '24MerchantDisabledFill': '24-merchant-disabled-fill.svg',
  '24MerchantDisabledLine': '24-merchant-disabled-line.svg',
  '24MerchantFill': '24-merchant-fill.svg',
  '24MerchantLine': '24-merchant-line.svg',
  '24MicrophoneFill': '24-microphone-fill.svg',
  '24MicrophoneLine': '24-microphone-line.svg',
  '24MoneyBank': '24-money-bank.svg',
  '24MoneyCircleDisabledFill': '24-money-circle-disabled-fill.svg',
  '24MoneyCircleDisabledLine': '24-money-circle-disabled-line.svg',
  '24MoneyCircleEnabledFill': '24-money-circle-enabled-fill.svg',
  '24MoneyCircleEnabledLine': '24-money-circle-enabled-line.svg',
  '24MoneyCircleFill': '24-money-circle-fill.svg',
  '24MoneyCircleLine': '24-money-circle-line.svg',
  '24MoneyDefault': '24-money-default.svg',
  '24MoneyEuro': '24-money-euro.svg',
  '24MoneyEuroCircleDisabledFill': '24-money-euro-circle-disabled-fill.svg',
  '24MoneyEuroCircleDisabledLine': '24-money-euro-circle-disabled-line.svg',
  '24MoneyEuroCircleEnabledFill': '24-money-euro-circle-enabled-fill.svg',
  '24MoneyEuroCircleEnabledLine': '24-money-euro-circle-enabled-line.svg',
  '24MoneyYen': '24-money-yen.svg',
  '24MoneyYenCircleDisabledFill': '24-money-yen-circle-disabled-fill.svg',
  '24MoneyYenCircleDisabledLine': '24-money-yen-circle-disabled-line.svg',
  '24MoneyYenCircleEnabledFill': '24-money-yen-circle-enabled-fill.svg',
  '24MoneyYenCircleEnabledLine': '24-money-yen-circle-enabled-line.svg',
  '24MoreHorizontal': '24-more-horizontal.svg',
  '24MoreVertical': '24-more-vertical.svg',
  '24NotifyFill': '24-notify-fill.svg',
  '24NotifyLine': '24-notify-line.svg',
  '24Number1Fill': '24-number-1-fill.svg',
  '24Number1Line': '24-number-1-line.svg',
  '24Number2Fill': '24-number-2-fill.svg',
  '24Number2Line': '24-number-2-line.svg',
  '24Number3Fill': '24-number-3-fill.svg',
  '24Number3Line': '24-number-3-line.svg',
  '24Number4Fill': '24-number-4-fill.svg',
  '24Number4Line': '24-number-4-line.svg',
  '24Number5Fill': '24-number-5-fill.svg',
  '24Number5Line': '24-number-5-line.svg',
  '24Number6Fill': '24-number-6-fill.svg',
  '24Number6Line': '24-number-6-line.svg',
  '24Number7Fill': '24-number-7-fill.svg',
  '24Number7Line': '24-number-7-line.svg',
  '24Number8Fill': '24-number-8-fill.svg',
  '24Number8Line': '24-number-8-line.svg',
  '24Number9Fill': '24-number-9-fill.svg',
  '24Number9Line': '24-number-9-line.svg',
  '24Office': '24-office.svg',
  '24OrderBagFill': '24-order-bag-fill.svg',
  '24OrderBagLine': '24-order-bag-line.svg',
  '24OrderBatchFill': '24-order-batch-fill.svg',
  '24OrderBatchLine': '24-order-batch-line.svg',
  '24OrderHotbagFill': '24-order-hotbag-fill.svg',
  '24OrderHotbagLine': '24-order-hotbag-line.svg',
  '24OrderIncorrectFill': '24-order-incorrect-fill.svg',
  '24OrderIncorrectLine': '24-order-incorrect-line.svg',
  '24OrderLargeFill': '24-order-large-fill.svg',
  '24OrderLargeFillFrCa': '24-order-large-fill-fr-ca.svg',
  '24OrderLargeLine': '24-order-large-line.svg',
  '24OrderLargeLineFrCa': '24-order-large-line-fr-ca.svg',
  '24OrderMediumFill': '24-order-medium-fill.svg',
  '24OrderMediumFillFrCa': '24-order-medium-fill-fr-ca.svg',
  '24OrderMediumLine': '24-order-medium-line.svg',
  '24OrderMediumLineFrCa': '24-order-medium-line-fr-ca.svg',
  '24OrderProtocol': '24-order-protocol.svg',
  '24OrderSmallFill': '24-order-small-fill.svg',
  '24OrderSmallFillFrCa': '24-order-small-fill-fr-ca.svg',
  '24OrderSmallLine': '24-order-small-line.svg',
  '24OrderSmallLineFrCa': '24-order-small-line-fr-ca.svg',
  '24ParkingEsMxFill': '24-parking-es-mx-fill.svg',
  '24ParkingEsMxLine': '24-parking-es-mx-line.svg',
  '24ParkingFill': '24-parking-fill.svg',
  '24ParkingLine': '24-parking-line.svg',
  '24PauseFill': '24-pause-fill.svg',
  '24PauseLine': '24-pause-line.svg',
  '24PaymentFill': '24-payment-fill.svg',
  '24PaymentLine': '24-payment-line.svg',
  '24PeopleAddFill': '24-people-add-fill.svg',
  '24PeopleAddLine': '24-people-add-line.svg',
  '24PeopleGroupFill': '24-people-group-fill.svg',
  '24PeopleGroupLine': '24-people-group-line.svg',
  '24PersonFindFill': '24-person-find-fill.svg',
  '24PersonFindLine': '24-person-find-line.svg',
  '24PersonProfileFill': '24-person-profile-fill.svg',
  '24PersonProfileLine': '24-person-profile-line.svg',
  '24PersonUserFill': '24-person-user-fill.svg',
  '24PersonUserLine': '24-person-user-line.svg',
  '24PetsFill': '24-pets-fill.svg',
  '24PetsLine': '24-pets-line.svg',
  '24PharmacyFill': '24-pharmacy-fill.svg',
  '24PharmacyLine': '24-pharmacy-line.svg',
  '24PhoneCallFill': '24-phone-call-fill.svg',
  '24PhoneCallLine': '24-phone-call-line.svg',
  '24PhotoFill': '24-photo-fill.svg',
  '24PhotoFlipFill': '24-photo-flip-fill.svg',
  '24PhotoFlipLine': '24-photo-flip-line.svg',
  '24PhotoLine': '24-photo-line.svg',
  '24PhotoRotateFill': '24-photo-rotate-fill.svg',
  '24PhotoRotateLine': '24-photo-rotate-line.svg',
  '24PhotoUploadFill': '24-photo-upload-fill.svg',
  '24PhotoUploadLine': '24-photo-upload-line.svg',
  '24PhotosFill': '24-photos-fill.svg',
  '24PhotosLine': '24-photos-line.svg',
  '24PlayFill': '24-play-fill.svg',
  '24PlayLine': '24-play-line.svg',
  '24PluginFill': '24-plugin-fill.svg',
  '24PluginLine': '24-plugin-line.svg',
  '24PrintFill': '24-print-fill.svg',
  '24PrintLine': '24-print-line.svg',
  '24PrismFill': '24-prism-fill.svg',
  '24PrismLine': '24-prism-line.svg',
  '24ProhibitedFill': '24-prohibited-fill.svg',
  '24ProhibitedLine': '24-prohibited-line.svg',
  '24PromoBullhornFill': '24-promo-bullhorn-fill.svg',
  '24PromoBullhornLine': '24-promo-bullhorn-line.svg',
  '24PromoFill': '24-promo-fill.svg',
  '24PromoLine': '24-promo-line.svg',
  '24RadioOffCircleLine': '24-radio-off-circle-line.svg',
  '24RadioOnCircleFill': '24-radio-on-circle-fill.svg',
  '24RearrangeVertical': '24-rearrange-vertical.svg',
  '24ReceiptCancelOrderFill': '24-receipt-cancel-order-fill.svg',
  '24ReceiptCancelOrderLine': '24-receipt-cancel-order-line.svg',
  '24ReceiptFill': '24-receipt-fill.svg',
  '24ReceiptLine': '24-receipt-line.svg',
  '24RefundFill': '24-refund-fill.svg',
  '24RefundLine': '24-refund-line.svg',
  '24RewardFill': '24-reward-fill.svg',
  '24RewardLine': '24-reward-line.svg',
  '24RobotFill': '24-robot-fill.svg',
  '24RobotLine': '24-robot-line.svg',
  '24Rotate': '24-rotate.svg',
  '24RunTest': '24-run-test.svg',
  '24RunTestFill': '24-run-test-fill.svg',
  '24SafetyFill': '24-safety-fill.svg',
  '24SafetyLine': '24-safety-line.svg',
  '24SatelliteFill': '24-satellite-fill.svg',
  '24SatelliteLine': '24-satellite-line.svg',
  '24Scan': '24-scan.svg',
  '24Search': '24-search.svg',
  '24SearchFill': '24-search-fill.svg',
  '24SearchLine': '24-search-line.svg',
  '24Send': '24-send.svg',
  '24SendFill': '24-send-fill.svg',
  '24SendLine': '24-send-line.svg',
  '24SettingsFill': '24-settings-fill.svg',
  '24SettingsLine': '24-settings-line.svg',
  '24ShareFill': '24-share-fill.svg',
  '24ShareLine': '24-share-line.svg',
  '24SignalHigh': '24-signal-high.svg',
  '24SignalLow': '24-signal-low.svg',
  '24SignalMedium': '24-signal-medium.svg',
  '24SkewHorizontalFill': '24-skew-horizontal-fill.svg',
  '24SkewHorizontalLine': '24-skew-horizontal-line.svg',
  '24SkewVerticalFill': '24-skew-vertical-fill.svg',
  '24SkewVerticalLine': '24-skew-vertical-line.svg',
  '24SmileyHappyFill': '24-smiley-happy-fill.svg',
  '24SmileyHappyLine': '24-smiley-happy-line.svg',
  '24SmileyNeutralFill': '24-smiley-neutral-fill.svg',
  '24SmileyNeutralLine': '24-smiley-neutral-line.svg',
  '24SmileySadFill': '24-smiley-sad-fill.svg',
  '24SmileySadLine': '24-smiley-sad-line.svg',
  '24Sort': '24-sort.svg',
  '24SortOrder': '24-sort-order.svg',
  '24Sos': '24-sos.svg',
  '24SpellingFill': '24-spelling-fill.svg',
  '24SpellingLine': '24-spelling-line.svg',
  '24StarFill': '24-star-fill.svg',
  '24StarHalf': '24-star-half.svg',
  '24StarLine': '24-star-line.svg',
  '24Subtract': '24-subtract.svg',
  '24SubtractCircleFill': '24-subtract-circle-fill.svg',
  '24SubtractCircleLine': '24-subtract-circle-line.svg',
  '24SubtractSquareFill': '24-subtract-square-fill.svg',
  '24SubtractSquareLine': '24-subtract-square-line.svg',
  '24Swap': '24-swap.svg',
  '24SwapCircleFill': '24-swap-circle-fill.svg',
  '24SwapCircleLine': '24-swap-circle-line.svg',
  '24Sync': '24-sync.svg',
  '24ThumbsDownFill': '24-thumbs-down-fill.svg',
  '24ThumbsDownLine': '24-thumbs-down-line.svg',
  '24ThumbsUpFill': '24-thumbs-up-fill.svg',
  '24ThumbsUpLine': '24-thumbs-up-line.svg',
  '24TimeFill': '24-time-fill.svg',
  '24TimeLine': '24-time-line.svg',
  '24TippingFill': '24-tipping-fill.svg',
  '24TippingLine': '24-tipping-line.svg',
  '24TipsStaffFill': '24-tips-staff-fill.svg',
  '24TipsStaffLine': '24-tips-staff-line.svg',
  '24ToteFill': '24-tote-fill.svg',
  '24ToteLine': '24-tote-line.svg',
  '24TrashFill': '24-trash-fill.svg',
  '24TrashLine': '24-trash-line.svg',
  '24TrashRestoreFill': '24-trash-restore-fill.svg',
  '24TrashRestoreLine': '24-trash-restore-line.svg',
  '24TrendDownCaret': '24-trend-down-caret.svg',
  '24TrendUpCaret': '24-trend-up-caret.svg',
  '24UnlockedFill': '24-unlocked-fill.svg',
  '24UnlockedLine': '24-unlocked-line.svg',
  '24UploadFill': '24-upload-fill.svg',
  '24UploadLine': '24-upload-line.svg',
  '24VehicleAirplane': '24-vehicle-airplane.svg',
  '24VehicleBikeFill': '24-vehicle-bike-fill.svg',
  '24VehicleBikeLine': '24-vehicle-bike-line.svg',
  '24VehicleCar': '24-vehicle-car.svg',
  '24VehicleEbikeFill': '24-vehicle-ebike-fill.svg',
  '24VehicleEbikeLine': '24-vehicle-ebike-line.svg',
  '24VehicleMotorcycleFill': '24-vehicle-motorcycle-fill.svg',
  '24VehicleMotorcycleLine': '24-vehicle-motorcycle-line.svg',
  '24VehicleScooterFill': '24-vehicle-scooter-fill.svg',
  '24VehicleScooterLine': '24-vehicle-scooter-line.svg',
  '24VehicleWalk': '24-vehicle-walk.svg',
  '24ViewCollapse': '24-view-collapse.svg',
  '24ViewExpand': '24-view-expand.svg',
  '24VolumeHighFill': '24-volume-high-fill.svg',
  '24VolumeHighLine': '24-volume-high-line.svg',
  '24VolumeLowFill': '24-volume-low-fill.svg',
  '24VolumeLowLine': '24-volume-low-line.svg',
  '24VolumeMuteFill': '24-volume-mute-fill.svg',
  '24VolumeMuteLine': '24-volume-mute-line.svg',
  '24VolumeNoneFill': '24-volume-none-fill.svg',
  '24VolumeNoneLine': '24-volume-none-line.svg',
  '24WarningCircleFill': '24-warning-circle-fill.svg',
  '24WarningCircleLine': '24-warning-circle-line.svg',
  '24WarningFill': '24-warning-fill.svg',
  '24WarningLine': '24-warning-line.svg',
  '24WarningTriangleFill': '24-warning-triangle-fill.svg',
  '24WarningTriangleLine': '24-warning-triangle-line.svg',
  '24Wifi0Line': '24-wifi-0-line.svg',
  '24Wifi1Line': '24-wifi-1-line.svg',
  '24Wifi2Line': '24-wifi-2-line.svg',
  '24Wifi3Line': '24-wifi-3-line.svg',
  '24Wifi4Line': '24-wifi-4-line.svg',
  '24WifiErrorLine': '24-wifi-error-line.svg',
  '24WifiOffLine': '24-wifi-off-line.svg',
  '24WineFill': '24-wine-fill.svg',
  '24WineLine': '24-wine-line.svg',
  '24ZoomInFill': '24-zoom-in-fill.svg',
  '24ZoomInLine': '24-zoom-in-line.svg',
  '24ZoomOutFill': '24-zoom-out-fill.svg',
  '24ZoomOutLine': '24-zoom-out-line.svg'
};
exports.availableAssets = availableAssets;